import { glass } from "../tokens/glass";

/**
 * Circular glass FAB — drop-in replacement for the four FAB call sites
 * in UploadFloor.js that previously stacked literal `blur(12px)` over
 * the live floor plan. Same shape, no backdrop-filter.
 *
 *   • size:     custom (52 for every FAB in the editor row).
 *   • elevated: when true, returns the heavier shadow used by the hero
 *               Shuffle button when saveIsPrimary === false (solid white).
 */
export function getFabCircleGlassSx({ size = 52, elevated = false } = {}) {
  if (elevated) {
    return {
      width: size,
      height: size,
      borderRadius: "50%",
      background: glass.backgroundSolid,
      border: "none",
      boxShadow: glass.shadowElevatedFab,
      backdropFilter: glass.backdropFilter,
      WebkitBackdropFilter: glass.WebkitBackdropFilter,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };
  }
  return {
    width: size,
    height: size,
    borderRadius: "50%",
    background: glass.backgroundElevated,
    border: glass.border,
    boxShadow: glass.shadowFab,
    backdropFilter: glass.backdropFilter,
    WebkitBackdropFilter: glass.WebkitBackdropFilter,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
}
